import React from 'react';
import {MENU_BANDS} from '../../../../../../config/TextContent';
import MenuItem from '../MenuItem';

const ElementBands = props => {
    return (
        <MenuItem 
            name={MENU_BANDS}
            link={props.link}
            img='/img/icons/disco-ball-green.svg' 
            active={props.active}
            onClick={props.onClick}
        />
    );
}
 
export default ElementBands;
